import React, { useEffect, useState } from "react";
import axios from "axios";
import { serviceConfig } from "configs";
import RadioButton from "common/RadioButton/RadioButton";
import { Input } from "common/Input/Input";

import { Htag } from "common/Htag/Htag";
import { P } from "common/P/P";
import FileItem from "common/FileItem/FolderItem";
import { Spinner } from "modules/loaders";
import PdfViewer from "common/PdfViewer/PdfViewer";
import OrdersTable from "components/OrderTable/OrdersTable";
import Pagination from "components/Pagination/Pagination";
import DIHTable from "components/DIHTable/DIHTable";
import IGHTable from "components/IGHTable/IGHTable";
import { Button } from "common/Button/Button";

const AllLettersPage = () => {
	const [documentType, setDocumentType] = useState("dgh");
	const [isLoading, setIsLoading] = useState(false);
	const [currentPage, setCurrentPage] = useState(1);
	const [letters, setLetters] = useState([]);

	const handleDocumentTypeChange = (e: any) => {
		setDocumentType(e.target.value);
		setCurrentPage(1); // Reset to first page on document type change
	};
	const itemsPerPage = 10;

	useEffect(() => {
		const fetchAllLetters = async () => {
			setIsLoading(true);
			try {
				const url = `${serviceConfig.apiUrl}/${documentType}`;
				const response = await axios.get(url);
				if (response.data.success) {
					setLetters(response.data.data);
				}
			} catch (error) {
				console.error(`Error fetching ${documentType} letters:`, error);
			} finally {
				setIsLoading(false);
			}
		};

		fetchAllLetters();
	}, [documentType]);

	// Calculate total pages based on the length of letters and itemsPerPage
	const totalPages = Math.ceil(letters.length / itemsPerPage);

	// Calculate the letters to display on the current page
	const indexOfLastLetter = currentPage * itemsPerPage;
	const indexOfFirstLetter = indexOfLastLetter - itemsPerPage;
	const currentLetters = letters.slice(indexOfFirstLetter, indexOfLastLetter);

	return (
		<div className="grid grid-flow-row auto-rows-max gap-6 px-6 py-6 min-h-[90vh]">
			<div className="grid grid-cols-1 gap-6">
				<div className="grid grid-cols-1 gap-2">
					<Htag tag="h2" type="medium" className="text-mainColor">
						Resminamanyň görnüşi
					</Htag>

					<div className="grid gap-6 grid-cols-maxFour">
						<RadioButton
							name="documentType"
							value="dgh"
							label="Daşarky gelen resminamalar"
							checked={documentType === "dgh"}
							onChange={handleDocumentTypeChange}
							id="dgh"
						/>
						<RadioButton
							name="documentType"
							value="dih"
							label="Daşarky iberilen resminamalar"
							checked={documentType === "dih"}
							onChange={handleDocumentTypeChange}
							id="dih"
						/>
						<RadioButton
							name="documentType"
							value="igh"
							label="Içerki gelen resminamalar"
							checked={documentType === "igh"}
							onChange={handleDocumentTypeChange}
							id="igh"
						/>
						<RadioButton
							name="documentType"
							value="iih"
							label="Içerki iberilen resminamalar"
							checked={documentType === "iih"}
							onChange={handleDocumentTypeChange}
							id="iih"
						/>
					</div>
				</div>
			</div>
			{isLoading ? (
				<Spinner />
			) : (
				<div>
					{documentType === "dgh" ? (
						<OrdersTable orders={currentLetters} type="dgh" deletable={true} />
					) : documentType === "dih" ? (
						<DIHTable orders={currentLetters} type="dih" deletable={true} />
					) : documentType === "igh" ? (
						<IGHTable orders={currentLetters} type="igh" deletable={true} />
					) : documentType === "iih" ? (
						<IGHTable orders={currentLetters} type="iih" deletable={true} />
					) : null}
					<div className="grid grid-cols-maxTwo place-content-between place-items-center py-[14px] px-[20px] border-x border-b border-strokeColor rounded-b-md">
						<P size="t2" type="regular" className="text-grayTwo">
							Jemi {letters.length} sany
						</P>
						<Pagination
							currentPage={currentPage}
							totalPages={totalPages}
							onPageChange={setCurrentPage}
						/>
					</div>
				</div>
			)}
		</div>
	);
};

export default AllLettersPage;
